import React, { useRef, useState } from 'react';
import styled from 'styled-components';
import { Chip, CustomerIcon, Tooltip } from '@routific/hive/v5';
import { useTranslation } from 'react-i18next';

const ProfileChip = styled(Chip)`
  max-width: 100%;
  min-width: 0;
`;

const Wrapper = styled.span`
  display: inline-flex;
  max-width: 100%;
  min-width: 0;
`;

interface Props {
  name?: string | null;
  onOpen?: (source: HTMLElement) => void;
}

const CustomerProfileBadge: React.FC<Props> = ({ name, onOpen }) => {
  const { t } = useTranslation('components');
  const label = name?.trim() || t('customerProfilesPage.untitledProfile');
  const wrapper = useRef<HTMLSpanElement>(null);
  const [showFullName, setShowFullName] = useState(false);

  const showNameIfTruncated = () => {
    setShowFullName(Array.from(wrapper.current?.querySelectorAll('*') ?? [])
      .some(element => element.scrollWidth > element.clientWidth));
  };

  return (
    <Tooltip title={label} open={showFullName} placement="top" wrapperStyle={{ maxWidth: '100%', minWidth: 0 }}>
      <Wrapper
        ref={wrapper}
        onMouseEnter={showNameIfTruncated}
        onMouseLeave={() => setShowFullName(false)}
        onFocus={showNameIfTruncated}
        onBlur={() => setShowFullName(false)}
      >
        <ProfileChip
          size="md"
          color="neutral"
          variant="outlined"
          startIcon={<CustomerIcon size="sm" />}
          aria-label={onOpen ? t('linkedCustomer.viewProfile', { name: label }) : undefined}
          onClick={onOpen ? event => onOpen(event.currentTarget) : undefined}
          data-testid="linked-customer-badge"
        >
          {label}
        </ProfileChip>
      </Wrapper>
    </Tooltip>
  );
};

export default CustomerProfileBadge;
